import { Review } from "./review"
export class GoodReview {
    constructor(good_review) {
        this.active  = good_review.active;
        this.content = good_review.content ? this.getReviewContent(good_review.content) : [];
    }

    changeActive() {
        this.active = !this.active;
    }

    getReviewContent(content) {
        let arr_review = [];
        for(let i = 0; i < content.length; i++) {
            arr_review.push(new Review(content[i]));
        }
        return arr_review;
    }

    getActiveReview() {
        let arr_review = [];
        for(let i = 0; i < this.content.length; i++) {
            if(this.content[i].status != 0) {
                arr_review.push(this.content[i]);
            }
        }
        return arr_review;
    }

    getReview(status = 1) {
        let arr_review = [];
        for(let i = 0; i < this.content.length; i++) {
            if(this.content[i].status == status) {
                arr_review.push(this.content[i]);
            }
        }
        return arr_review;
    }

    addNewReview() {
        this.content.push(new Review({id: null, content: '', status: 3}));
    }
    removeReview(index) {
        this.content.splice(index, 1);
    }
}